import React from "react";
import { Box, Typography } from "@mui/material";

const baseNoticeSx = {
  pointerEvents: "none",
  textAlign: "center",
  px: 1.5,
  py: 0.75,
  borderRadius: "999px",
  backgroundColor: "rgba(92, 177, 226, 0.10)",
  border: "1px solid rgba(92, 177, 226, 0.35)",
  backdropFilter: "blur(2px)",
};

const captionSx = {
  color: "#3a7fa8",
  fontWeight: 500,
  fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
  lineHeight: 1.3,
};

function InstallationTypeNotice({ isMobile = false, variant = "overlay" }) {
  const stepLabel = isMobile ? 2 : 3;

  if (variant === "inline") {
    return (
      <Box
        sx={{
          ...baseNoticeSx,
          mx: "auto",
          mb: 2,
          maxWidth: "92%",
        }}
      >
        <Typography variant="caption" sx={captionSx}>
          Vous pourrez modifier le type d&apos;installation à l&apos;étape {stepLabel}.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...baseNoticeSx,
        position: "absolute",
        bottom: { md: 16 },
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 4,
        maxWidth: { md: "85%" },
      }}
    >
      <Typography variant="caption" sx={captionSx}>
        Vous pourrez modifier le type d&apos;installation à l&apos;étape {stepLabel}.
      </Typography>
    </Box>
  );
}

export default InstallationTypeNotice;
